// extracted by mini-css-extract-plugin
export var fullHeightState = "_4p-7";
export var headerCell = "_4p-1";
export var loadingStateCell = "_4p-4";
export var rowWrapper = "_4p-3";
export var standaloneTable = "_4p-8";
export var standaloneTableWithBodyFill = "_4p-9";
export var stateCell = "_4p-5";
export var table = "_4p-0";
export var tableBodyFiller = "_4p-6";
export var white = "_4p-2";